(function (angular) {

  angular.module("alk.authentication", []);

})(window.angular);

require("./service/alkAuthenticationService");
require("./factories/changePassword.factory");
require("./factories/forgotPassword.factory");
require("./factories/login.factory");
require("./factories/resetPassword.factory");



// WEBPACK FOOTER //
// ./Common Javascript Files/AngularJS/alk-authentication/module.js